import type { ChangeEvent } from 'react';

/*
 * Helper function to trim left change event value
 * Usage: onChange={trimValueLeft(handleChange)}
 */
export const trimValueLeft =
  (onChange: (e: ChangeEvent<HTMLInputElement>) => void) =>
  (e: ChangeEvent<HTMLInputElement>): void => {
    e.target.value = e.target.value.trimLeft();
    onChange(e);
  };

/*
 * Helper function to trim change event value
 * Usage: onChange={trimValue(handleChange)}
 */
export const trimValue =
  (onChange: (e: ChangeEvent<HTMLInputElement>) => void) =>
  (e: ChangeEvent<HTMLInputElement>): void => {
    e.target.value = e.target.value.trim();
    onChange(e);
  };
